import Vue from 'vue'
import { 
    Button,
    Tabs,
    TabPane,
    Carousel,
    CarouselItem
} from 'element-ui'
// Vue.prototype.$ELEMENT = { size: 'small', zIndex: 3000 }
Vue.use(Button)
Vue.use(Tabs);
Vue.use(TabPane);
Vue.use(Carousel);
Vue.use(CarouselItem)
